import React from 'react'
import i18n from 'live/services/i18n'
import styled from 'styled-components'

export function OverweightDialogContent(): JSX.Element {
    return (
        <StyledOverweightData>
            <b>{i18n('One or more weights are overweight. Would you like to continue anyway?')}</b>
        </StyledOverweightData>
    )
}

const StyledOverweightData = styled.div`
    color: #cc5757;
`
